const normalizePath = path => typeof path === 'string' ? (path.split(/[?#]/)[0].replace(/\/+$/, '') || '/').toLowerCase() : '';

export function safeLandingPath(value, fallback = '/home') {
    if (typeof value !== 'string') return fallback;
    try { const decoded = JSON.parse(value); if (typeof decoded === 'string') value = decoded; } catch (error) { /* Legacy plain path. */ }
    if (!value.startsWith('/') || value.startsWith('//') || value.includes('\\') || Array.from(value).some(char => char.charCodeAt(0) < 32)
        || ['/', '/login', '/logout'].includes(normalizePath(value))) return fallback;
    return value;
}

export function allowedTab(tab, group, license) {
    return !!tab && !!license && Array.isArray(tab.groupid) && tab.groupid.some(id => Number(id) === Number(group))
        && Array.isArray(tab.perms) && tab.perms.some(key => key === 'any' || license[key] === true || license[key] === 1);
}

export function routeMenuContext(menu, license, group, path, preferred) {
    if (Number(group) < 1 || !license || !menu || !menu[license.activemenu]) return null;
    const candidates = Object.values(menu[license.activemenu]).filter(entry => entry && entry.main && Array.isArray(entry.main.groupid)
        && entry.main.groupid.some(id => Number(id) === Number(group)) && entry.main.frame !== 'logout');
    const matches = candidates.filter(entry => Object.values(entry.sub || {}).some(tab => normalizePath(tab.href) === normalizePath(path) && allowedTab(tab, group, license)));
    return matches.find(entry => String(entry.main.index) === String(preferred)) || matches[0] || null;
}

export function contextualTabs(tabs, menu, license, group, path, lang, preferred) {
    const supplied = Array.isArray(tabs) ? tabs : [];
    if (supplied.some(tab => normalizePath(tab.href) === normalizePath(path) && allowedTab(tab, group, license))) return supplied;
    const context = routeMenuContext(menu, license, group, path, preferred);
    if (!context) return supplied;
    return Object.values(context.sub || {}).filter(tab => allowedTab(tab, group, license)).map(tab => ({...tab,
        name: lang === 'ar' ? tab.arname : lang === 'ur' ? (tab.urname || tab.enname) : tab.enname,
        class: normalizePath(tab.href) === normalizePath(path) ? 'mytab' : 'mytab4',
    }));
}
